import { Routes, Route } from 'react-router-dom';
import { Container } from "@mui/material";
import CssBaseline from '@mui/material/CssBaseline';
import { AppProvider, ProtectedRoute } from './AppContext';
import AppTheme from './templates/shared-theme/AppTheme';

import AppBar from "./components/AppBar";
import Footer from "./components/Footer";
import ScrollTop from './components/ScrollTop';

import Home from "./pages/Home";
import SignIn from './pages/SignIn';
import Me from './pages/Me';
import CreateUser from './pages/CreateUser';
import TopUp from './pages/TopUp';
import TopUpComplete from './pages/TopUpComplete';
import Profiles from './pages/Profiles';

import ParticipationTerm from './pages/ParticipationTerm';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import TrainerSuccessGuide from './pages/TrainerSuccessGuide';
import BecomeTrainer from './pages/BecomeTrainer';

function TermsContainer(props) {
  return (
    <>
      <WithFooter>
        <Container
          maxWidth="lg"
          component="main"
          sx={{ display: 'flex', flexDirection: 'column', my: 16, gap: 4 }}
        >
          {props.children}
        </Container>
      </WithFooter>
    </>
  )
}

function WithFooter(props) {
  return (
    <>
      {props.children}
      <Footer />
    </>
  )
}

function App() {
  return (
    <>
      <AppProvider>
        <AppTheme>
          <AppBar />
          <div id="back-to-top-anchor"></div>
          <CssBaseline enableColorScheme />

          <Routes>
            <Route path="/" element={
              <WithFooter>
                <Home />
              </WithFooter>
            } />
            <Route path="/signin" element={
              <SignIn signUp={false} />
            } />
            <Route path="/signup" element={
              <SignIn signUp={true} />
            } />
            <Route path="/createUser" element={
              <CreateUser />
            } />
            <Route path="/me" element={
              <ProtectedRoute>
                <WithFooter>
                  <Me />
                </WithFooter>
              </ProtectedRoute>
            } />
            <Route path="/topup" element={
              <ProtectedRoute>
                <WithFooter>
                  <TopUp />
                </WithFooter>
              </ProtectedRoute>
            } />
            <Route path="/topup/complete" element={
              <WithFooter>
                <TopUpComplete />
              </WithFooter>
            } />
            <Route path="/profiles" element={
              <WithFooter>
                <Profiles />
              </WithFooter>
            } />

            {/* Terms and Policies */}
            <Route path="/participation-term.html" element={
              <TermsContainer>
                <ParticipationTerm />
              </TermsContainer>
            } />
            <Route path="/privacy-policy.html" element={
              <TermsContainer>
                <PrivacyPolicy />
              </TermsContainer>
            } />
            <Route path="/terms-and-conditions.html" element={
              <TermsContainer>
                <TermsAndConditions />
              </TermsContainer>
            } />
            <Route path="/trainer-success-guide.html" element={
              <TermsContainer>
                <TrainerSuccessGuide />
              </TermsContainer>
            } />
            <Route path="/how-to-become-a-trainer.html" element={
              <TermsContainer>
                <BecomeTrainer />
              </TermsContainer>
            } />
          </Routes>
          <ScrollTop />
        </AppTheme>
      </AppProvider>
    </>
  );
}

export default App;
